import { createRoot } from 'react-dom/client';
import CloseSlab from '../slab/Close';
function Create(component) {
  CloseSlab();
  const div = document.createElement('div');
  createRoot(
    document.getElementById('panel-container').appendChild(div),
  ).render(component);
}

export default Create;
